<template>
    <div>
        <div v-if="hasAccess">
            <div id="webix-box" class="shared-webix">
                <flash-message></flash-message>
                <div class="text-followup-nav mb-5">
                    <div v-if="project" class="text-2xl text-grey-darkest mb-4">Project Resources for
                        {{ projectName ? projectName : '' }}
                    </div>
                    <div v-else class="text-2xl text-grey-darkest mb-4">Resources</div>
                </div>
                <div id="box" style="height:500px;"></div>
            </div>
        </div>
        <div v-else>
            <div class="modal fade" id="sharedDocumentAccessModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Verify your email</h5>
                        </div>
                        <div class="modal-body">
                            <div class="row mb-3">
                                <div class="col-md-8">
                                    <input type="email" v-model="userEmail" class="form-control" placeholder="Enter your email">
                                </div>
                                <div class="col-md-4">
                                    <button class="btn btn-primary text-sm w-full" :disabled="countdown > 0" @click="sendOTP">
                                        {{ countdown > 0 ? countdown + 's to resend' : 'Send One Time Password' }}
                                    </button>
                                </div>
                            </div>
                            <div class="row mb-3" v-if="showOTPAndVerifyField" id="otpMessage">
                                <div class="col-md-12 text-sm text-primary">
                                    {{otpMessage}}
                                </div>
                            </div>
                            <div class="row" v-if="showOTPAndVerifyField">
                                <div class="col-md-9">
                                    <input type="text" v-model="otp" class="form-control" placeholder="Enter One Time Password">
                                </div>
                                <div class="col-md-3">
                                    <button class="btn btn-primary text-sm w-full" @click="verifyOTP()">
                                        Verify
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/blured-shared-resouce.jpg">
        </div>
    </div>
</template>

<script>

import axios from "axios";

export default {
    name: "shared-resource-files-webix",
    components: {},
    props: ['team_id', 'user_id', 'project', 'projectName', 'url', 'clean', 'hasAccess', 'projectDocumentSharingId', 'folderIds'],

    data() {
        return {
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            companyCamSyncLoading:false,
            userEmail: '',
            countdown: 0,
            timerId: null,
            showOTPAndVerifyField: false,
            otp: '',
            otpMessage: 'One Time Password sent to your email',
            fileManagerObj: null,
        };
    },

    created() {
        if(!this.hasAccess){
            this.openSharedDocumentAccessModal();
        }else{
            this.getUrl();
            this.fileManager();
            this.checkWebixForUploadButton();
        }
    },

    methods: {
        customRefresh() {
            document.getElementById('box').innerHTML = '';
            document.getElementById('webix-box').innerHTML = '<div id="box" style="height:500px;"></div>';
        },
        getUrl() {
            let self = this;
            let folderIds = (self.folderIds.length > 0)? self.folderIds:0;
            return self.url+'/api/webix-shared/shared-file-manager/' + (self.project.id ? self.project.id : 0) + '/'+ (self.team_id ? self.team_id : 0) + '/[' + folderIds + ']/';
        },
        fileManager() {
            const self = this;
            webix.ready(function() {
                if (webix.env.mobile) webix.ui.fullScreen();
                webix.CustomScroll.init();
                class MyBackend extends fileManager.services.Backend {
                    folders(id) {
                        let payload = {id};
                        return webix.ajax(self.getUrl() + 'folders', payload).then(res => res.json());
                    }
                    files(id) {
                        let payload = {id};
                        return webix.ajax(self.getUrl() + 'files', payload)
                            .then(res => res.json());
                    }
                    directLink(id, path, download) {
                        if(!download) {
                            window.open(path, '_blank');
                        }
                        else {
                            window.open(self.getUrl() + 'direct?id='+id, '_self');
                        }
                    }
                    previewURL(obj, width, height) {
                        if(obj.type == 'document') {
                            return obj.thumbnail;
                        }
                        else {
                            return obj.path;
                        }
                    }
                    search(id, search) {
                        let payload = {
                            id,
                            search
                        };
                        return webix.ajax(self.getUrl() + 'files', payload)
                            .then(res => res.json());
                    }
                    icon(type, size) {
                        //serve image/jpg for all icons
                        return `https://docs.webix.com/filemanager-backend/icons/${size ||
                        "small"}/image/${type.$ext}.svg`;
                    }
                    getInfo() {
                        //
                    }
                }
                webix.ui({
                    view: "filemanager",
                    id: "sharedWebixId",
                    container:"box",
                    url: self.getUrl(),
                    override: new Map([[fileManager.services.Backend, MyBackend]]),
                });
            });
        },
        openSharedDocumentAccessModal(){
            $(document).ready(function(){
                $('#sharedDocumentAccessModal').modal('show');
            });
        },
        sendOTP() {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if(this.userEmail.trim() == '' || this.userEmail == null || !re.test(this.userEmail)){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please enter a valid email address'
                });
                return false;
            }
            this.checkEmailAndSendOTP();
        },
        checkEmailAndSendOTP(){
            axios.post(route('document-share.check-email-and-send-otp'), {projectDocumentSharingId: this.projectDocumentSharingId, teamId: this.team_id, userEmail: this.userEmail.trim()}).then(response => {
                if(response.data.status == 'error'){
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                    return false;
                }else{
                    this.showOTPAndVerifyField = true;
                    this.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        $('#otpMessage').hide(400);
                    }, 20000);

                    const duration = 60;
                    this.countdown = duration;
                    this.timerId = setInterval(() => {
                        this.countdown--;
                        if (this.countdown === 0) {
                            clearInterval(this.timerId);
                            this.timerId = null;
                        }
                    }, 1000);
                }
            });
        },
        verifyOTP(){
            if(this.otp.trim() == '' || this.otp.trim() == null){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please provide valid one time password'
                });
                return false;
            }

            axios.post(route('document-share.verify-otp'), {projectDocumentSharingId: this.projectDocumentSharingId, teamId: this.team_id, userEmail: this.userEmail.trim(), otp: this.otp}).then(response => {
                if(response.data.status == 'error'){
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }else{
                    this.getToast(3000).fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                }
            });
        },
        checkWebixForUploadButton(){
            let folderIds = (this.folderIds.length > 0)? this.folderIds:0;
            if (folderIds){
                var fManager = $$("sharedWebixId");
                if(fManager){
                    this.fileManagerObj = fManager.getState();
                    this.showOrRemoveButton();
                }

                setTimeout(() => {
                    this.checkWebixForUploadButton();
                }, 1000)
            }
        },
        showOrRemoveButton(){
            const specificClasses = ['webix_view', 'webix_control', 'webix_el_button', 'webix_primary'];

            if(this.fileManagerObj.path == '/'){
                this.hideElementsWithSpecificClasses(specificClasses);
                }else{
                this.showElementsWithSpecificClasses(specificClasses);
                }
        },

        hasAllSpecificClasses(element, classes) {
            return classes.every(cls => element.classList.contains(cls));
        },
        hideElementsWithSpecificClasses(classes) {
            const elements = document.querySelectorAll('*');

            elements.forEach(element => {
                if (this.hasAllSpecificClasses(element, classes)) {
                    element.style.display = 'none';
                }
            });
        },
        showElementsWithSpecificClasses(classes) {
            const elements = document.querySelectorAll('*');

            elements.forEach(element => {
                if (this.hasAllSpecificClasses(element, classes)) {
                    element.style.display = 'block';
                }
            });
        }

    },
}
</script>

<style>

</style>
